import * as React from 'react';

function Norm() {
    const getSrc = () => {
        const src =
            process.env.NODE_ENV === 'development'
                ? 'http://127.0.0.1:5000#/norm'
                : `${window.location.origin}/v3/vue#/norm`;
        return src;
    };
    return (
        <div className="main-content">
            <iframe src={`${getSrc()}`} frameBorder="no" width="100%" height="100%" />
        </div>
    );
}

export default Norm;
